
function commonStyles() {
    return(
        {
            btn: {
                padding: '16px',
                marginTop: '15px',
                fontWeight: '700',
                fontSize: '1.2rem',
            },
            btnForm: {
                padding: '10px 14px',
                marginTop: '15px',
                fontWeight: '700',
                fontSize: '1.2rem',
            },
            card: {
                width: '18rem',
                height: '26rem',
            },
            starterCard: {
                width: '18rem',
                height: '24rem',
            },
            forum1: {
                width: '18rem',
                height: '24rem',
            },
            forum: {
                width: '18rem',
                height: '28rem',
            },
            cardTitle: {
                fontSize: '2.3rem',
                marginBottom: '3.5rem'
            },
            cardRisultato: {
                fontSize: '1.2rem',
                width: '13rem',
                color: 'white',
            },
            mainTitle: {
                fontSize: '5rem',
                marginTop: '10%'
            },
            divRisultati: {
                display: 'flex',
                marginTop: '10%'
            },
            hr: {
                color: '#2ccbff'
            }
        }
    );
}

export default commonStyles()